import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable, of } from 'rxjs';
import { TableComponent } from 'projects/patient/src/app/components/table/table.component';
import { Column, Paging } from 'projects/shared-ui/src/public-api';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';


export interface PaymentRow {
  date: string;
  description: string;
  amount: number;
  status: 'Paid' | 'Pending';
}

@Component({
  selector: 'patient-payment-history',
  standalone: true,
  imports: [CommonModule, TableComponent, TableModule, TagModule],
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.scss'],
})
export class PaymentHistoryComponent implements OnInit{
  @Input() payments: PaymentRow[] = [];
  

  // columns: Column[] = [
  //   { header: 'Date', field: 'date' },
  //   { header: 'Description', field: 'description' },
  //   {
  //     header: 'Amount',
  //     field: 'amount',
  //     cellRenderer: (r: PaymentRow) => `₹${r.amount}`,
  //   },
  //   {
  //     header: 'Status',
  //     field: 'status',
  //     cellRenderer: (r: PaymentRow) =>
  //       r.status === 'Paid'
  //         ? '<span class="px-2 py-1 text-xs rounded-full bg-green-100 text-green-700 dark:bg-green-300/10 dark:text-green-300">Paid</span>'
  //         : '<span class="px-2 py-1 text-xs rounded-full bg-orange-100 text-orange-700 dark:bg-orange-300/10 dark:text-orange-300">Pending</span>',
  //   },
  // ];

  // getPaymentData = (paging: Paging): Observable<any> => {
  //   const start = (paging.pageNumber || 1 - 1) * (paging.pageSize || 0);
  //   const paged = this.rows.slice(start, start + (paging.pageSize || 5));
  //   return of({ data: paged, paging: { totalItems: this.rows.length } });
  // };
 statuses! : {
  label: string , value: string}

ngOnInit(): void {
 
}

getSeverity(status: 'Paid' | 'Pending'): "success" | "warning" {
  switch (status) {
    case 'Paid':
      return 'success';
    case 'Pending':
      return 'warning';
    default:
      return 'warning';
  }
}

  

columns: Column[] = [
  { field: 'date', header: 'Date', sortable: true, filterable: true },
  { field: 'description', header: 'Description', sortable: true, filterable: true },
  { field: 'amount', header: 'Amount', sortable: true, filterable: true, 
    cellRenderer: (row) => `${row.amount} ₹` },
  { field: 'status', header: 'Status', sortable: true, filterable: true, 
    cellRenderer: (row) => `<span class="badge">${row.status}</span>` },
];



  mockPayments = [
    { date: '2025-12-01', description: 'Electricity Bill', amount: 1200, status: 'Paid' },
    { date: '2025-12-05', description: 'Internet Bill', amount: 800, status: 'Pending' },
    { date: '2025-12-10', description: 'Water Bill', amount: 300, status: 'Overdue' },
    { date: '2025-12-15', description: 'Rent', amount: 15000, status: 'Paid' },
       { date: '2025-12-01', description: 'Electricity Bill', amount: 1200, status: 'Paid' },
    { date: '2025-12-05', description: 'Internet Bill', amount: 800, status: 'Pending' },
    { date: '2025-12-10', description: 'Water Bill', amount: 300, status: 'Overdue' },
    { date: '2025-12-15', description: 'Rent', amount: 15000, status: 'Paid' },
       { date: '2025-12-01', description: 'Electricity Bill', amount: 1200, status: 'Paid' },
    { date: '2025-12-05', description: 'Internet Bill', amount: 800, status: 'Pending' },
    { date: '2025-12-10', description: 'Water Bill', amount: 300, status: 'Overdue' },
    { date: '2025-12-15', description: 'Rent', amount: 15000, status: 'Paid' },
  ];

// getPayments = (paging: Paging) => {
//   return this.apiService.get('/payments', {
//     params: {
//       pageNumber: paging.pageNumber,
//       pageSize: paging.pageSize,
//       filter: paging.filter,
//       orderby: paging.orderby
//     }
//   });
// };

 getPayments = (paging: Paging) => {
   
    return of({
      data: this.mockPayments,
      paging: { totalItems: this.mockPayments.length },
    });
  };
}
